<template>
  <div>
    <validation-observer ref="medicamentoForm">
      <b-form @ubmit.prevent>
        <b-row>
          <b-col cols="12">
            <b-form-textarea
              v-model="medicamentosEmUso.medicamentosEmUso"
              :disabled="disableForm"
              rows="3"
              max-rows="6"
            />
          </b-col>
        </b-row>
        <b-row>
          <ButtonsFormVue
            label-edit="Editar Medicamentos em Uso"
            label-save="Salvar Medicamentos em Uso"
            :disable-form="disableForm"
            :loading-button="loading"
            :permission-insert="verificarPermissao('ROLE_PROFISSIONAL')"
            :permission-edit="verificarPermissao('ROLE_PROFISSIONAL')"
            @save="salvar"
            @edit="editar"
            @cancel="beforeCancelar"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import { BFormTextarea, BForm, BRow, BCol } from "bootstrap-vue";
import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue";
import mixinsGlobal from "@/mixins";
export default {
  components: {
    BFormTextarea,
    BForm,
    BRow,
    BCol,
    ValidationObserver,
    ButtonsFormVue,
  },
  mixins: [mixinsGlobal],
  props: {
    parecer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      disableForm: true,
      medicamentosEmUso: {},
    };
  },
  watch: {
    parecer: {
      handler(newVal) {
        this.setMedicamentoEmUsoData(newVal);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    beforeCancelar() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Deseja realmente sair da atualização do Medicamento Em Uso?",
          {
            title: "Confirmação",
            size: "sm",
            okVariant: "primary",
            okTitle: "Sim",
            cancelTitle: "Não",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          this.boxTwo = value;
          if (value) {
            this.cancelar();
          }
        });
    },
    cancelar() {
      this.disableForm = true;
      this.loadingCampos = false;
      this.setMedicamentoEmUsoData(this.parecer);
      this.$refs.medicamentoForm.reset();
      this.$emit("disable-form-changed", this.disableForm);
    },
    setMedicamentoEmUsoData(data) {
      if (data) {
        this.medicamentosEmUso.id = data.id;
        this.medicamentosEmUso.medicamentosEmUso = data.medicamentosEmUso;
      }
    },
    async editar() {
      this.disableForm = false;
      this.$emit("disable-form-changed", this.disableForm);
    },
    salvar(isAutoSave = false) {
      this.$refs.medicamentoForm.validate().then((success) => {
        if (success) {
          this.loading = true;
          try {
            this.$store
              .dispatch(
                "parecerCardiologicoModule/salvarMedicamentoEmUso",
                this.medicamentosEmUso
              )
              .then((response) => {
                this.medicamentosEmUso.id = response.data.id;
                this.medicamentosEmUso.medicamentosEmUso =
                  response.data.medicamentosEmUso;
                this.disableForm = true;
                this.showMessageSuccess(
                  "Editar",
                  "Medicamentos em Uso Editado com sucesso!"
                );
                this.$emit("disable-form-changed", this.disableForm);
              });
          } catch (error) {
            this.MensagemError("Salvar", "Falha ao salvar!");
          } finally {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>
